export class LocalStorageAuthStorage {
    key;
    constructor({ key }) {
        this.key = key;
    }
    read() {
        try {
            const lsItem = localStorage.getItem(this.key);
            return lsItem ? JSON.parse(lsItem) : undefined;
        }
        catch (err) {
            console.error('Error while reading auth data from localStorage', err);
            return undefined;
        }
    }
    save(data) {
        localStorage.setItem(this.key, JSON.stringify(data));
    }
    clear() {
        localStorage.removeItem(this.key);
    }
    subscribe(listener) {
        const listenerFn = (event) => {
            if (event.key === this.key) {
                listener();
            }
        };
        window.addEventListener('storage', listenerFn);
        return () => window.removeEventListener('storage', listenerFn);
    }
}
